import React from 'react'

export type CursorValue = [number | undefined, (n: number) => void]

export const CursorContext = React.createContext<CursorValue | undefined>(
  undefined,
)
